import { render, staticRenderFns } from "./HelpDialog.vue?vue&type=template&id=2814824f"
import script from "./HelpDialog.vue?vue&type=script&lang=ts"
export * from "./HelpDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports